
export const formatYearToDate = (year) => {
    if (!year) return null;
    
    const yearNum = parseInt(year);
    if (isNaN(yearNum) || yearNum < 1900 || yearNum > new Date().getFullYear()) {
        return null;
    }
    
    // Return January 1st of the year
    return new Date(Date.UTC(yearNum, 0, 1)).toISOString();
};

export const parseDateToYear = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    
    return date.getFullYear().toString();
};

export const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;
        
        // Format yyyy-MM-dd
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        return `${year}-${month}-${day}`;
    } catch (error) {
        return dateString;
    }
};

export const formatDateForAPI = (dateValue) => {
    if (!dateValue || dateValue === '') return null;
    
    // keeps format (YYYY-MM-DD)
    if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return dateValue;
    }
    
    try {
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return null;
        
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        
        return `${month}-${day}-${year}`;
    } catch (error) {
        return null;
    }
};